
namespace GeniuzPOS.Lookups {

    @Serenity.Decorators.registerClass()
    export class LookupBgColorGrid extends Serenity.EntityGrid<LookupBgColorRow, any> {
        protected getColumnsKey() { return LookupBgColorColumns.columnsKey; }
        protected getDialogType() { return LookupBgColorDialog; }
        protected getIdProperty() { return LookupBgColorRow.idProperty; }
        protected getInsertPermission() { return LookupBgColorRow.insertPermission; }
        protected getLocalTextPrefix() { return LookupBgColorRow.localTextPrefix; }
        protected getService() { return LookupBgColorService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}